'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaThumbsDown = function FaThumbsDown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.7 12.9q0 0.5-0.4 1t-1 0.4q-0.6 0-1-0.4t-0.4-1q0-0.6 0.4-1.1t1-0.4q0.6 0 1 0.4t0.4 1.1z m3.6 11.4v-14.3q0-0.6-0.4-1t-1-0.4h-6.5q-0.6 0-1 0.4t-0.4 1v14.3q0 0.6 0.4 1t1 0.4h6.5q0.5 0 1-0.4t0.4-1z m25.2-3.3q1.2 1.3 1.2 3.3 0 1.7-1.3 3t-3 1.3h-6.2q0.1 0.3 0.2 0.5t0.3 0.5 0.2 0.4q0.4 0.8 0.6 1.3t0.4 1.3 0.2 1.7q0 0.5 0 0.9t-0.1 1-0.2 1.1-0.6 1-0.9 0.9-1.3 0.6-1.9 0.2q-0.5 0-1-0.4-0.4-0.5-0.7-1.1t-0.5-1.2-0.2-1.4q-0.2-0.9-0.3-1.3t-0.4-1.1-0.7-1.1q-0.8-0.7-2.3-2.6-1.1-1.5-2.2-2.7t-1.7-1.4q-0.6 0-1-0.4t-0.4-1v-14.3q0-0.6 0.4-1t1-0.4q0.8-0.1 3.6-1 1.7-0.6 2.7-0.9t2.7-0.6 3.2-0.4h2.9q2.9 0.1 4.4 1.8 1.3 1.5 1.1 4 0.8 0.8 1.2 2.1 0.3 1.4 0 2.6 1 1.4 0.9 3.1 0 0.7-0.3 1.7z' })
        )
    );
};

exports.default = FaThumbsDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/thumbs-down.js
// module id = 859
// module chunks = 168707334958949